/*
 * Copyright (c) 2019 brightlamp
 */

import Axios from 'axios'
import { axiosInit } from './axiosSetup'
import { firebaseAuth, onAuthStateChanged, firebaseAnalytics, setUserId } from '@/firebase/firebase'
const clonedeep = require('lodash.clonedeep');
import { store } from '@/store'
import axiosRetry from 'axios-retry';
import { formatNumber } from './tests';
import { isBeforeCutoff } from './common';

export default
{
    namespaced: true,
    state:
    {
        routing: false,
        currentUser: null,
        currentUserChanges: null,
        seeOrganizationTests: false,
        latestPortalVer: 0,
        navDrawerToggle: false,
        searchValue: null,
        testProtocolSuite: localStorage.getItem('testProtocolSuite') ? JSON.parse(localStorage.getItem('testProtocolSuite')) : {testProtocols: []}
    },
    getters:
    {
        CURRENT_USER : state =>
        {
            return state.currentUser
        }
    },
    mutations:
    {
        SET_CURRENT_USER(state, payload)
        {
            state.currentUser = payload;
            state.currentUserChanges = clonedeep(payload);
            if (payload && state.currentUser.preferences)
            {
                state.seeOrganizationTests = state.currentUser.preferences.seeOrganizationTests
            }
        },
        SET_ROUTING(state, payload)
        {
            state.routing = payload
        },
        SET_SEE_ORGANIZATION_TESTS(state, payload)
        {
            state.seeOrganizationTests = payload
        },
        SET_SEARCH_VALUE(state, payload)
        {
            state.searchValue = payload
        },
        SET_LATEST_PORTAL_VER(state, payload)
        {
           state.latestPortalVer = payload
        },
        SET_NAV_DRAWER_TOGGLE(state, payload)
        {
            state.navDrawerToggle = payload
        },
        SET_TEST_PROTOCOL_SUITE(state, payload)
        {
            if (payload)
            {
                payload.lastTestProtocolSuiteUpdate = new Date().toISOString();
                state.testProtocolSuite = payload
            }
            else
            {
                state.testProtocolSuite.lastTestProtocolSuiteUpdate = new Date().toISOString()
            }
            localStorage.setItem('testProtocolSuite', JSON.stringify(state.testProtocolSuite))
        }
    },
    actions:
    {
        ROUTE_PENDING(context)
        {
            context.commit('SET_ROUTING', true)
        },
        ROUTE_COMPLETE(context)
        {
            context.commit('SET_ROUTING', false)
        },
        FETCH_AUTH(context)
        {
             return new Promise((resolve, reject) =>
             {
                 if (!this.state.auth.currentUser)
                 {
                     const unsubscribe = onAuthStateChanged(firebaseAuth, async user =>
                     {
                         unsubscribe();
                         if (user && null == this.state.auth.currentUser)
                         {
                             // console.log(await user.getIdToken())
                             try
                             {
                                 setUserId(firebaseAnalytics, user.uid);
                                 store.commit('common/SHOW_SNACKBAR_SUCCESS', 'Loading profile data...');
                                 const axios = Axios.create(
                                 {
                                     baseURL: process.env.VUE_APP_SERVER_URL + process.env.VUE_APP_ROOT_CONTEXT,
                                     headers: {'Authorization': `Bearer ${await user.getIdToken()}`}
                                 });
                                 axiosRetry(axios, {retries: 3, retryDelay: axiosRetry.exponentialDelay, shouldResetTimeout: false, retryCondition: (_error) => _error.response.status === 408 || _error.response.status === 500 || _error.response.status === 502 || _error.response.status === 503 || _error.response.status === 504});
                                 const response = await axios.get('/user');

                                 const provider = user.providerData.length > 0 ? user.providerData[0].providerId : '';
                                 // Update the provider field if it has changed
                                 if (provider !== response.data.provider)
                                 {
                                     response.data.provider = provider;
                                     await context.dispatch('UPDATE_CURRENT_USER', response.data)
                                 }

                                 updateAccountCommon(context, response.data, response.headers);
                                 store.commit('common/HIDE_SNACKBAR');
                                 resolve(this.state.auth.currentUser)
                             }
                             catch (error)
                             {
                                 store.commit('common/HIDE_SNACKBAR');
                                 if (404 === error.response.status)
                                 {
                                     const profile =
                                     {
                                         profileNeeded: true,
                                         displayName: user.displayName,
                                         emailAddress: user.email ? user.email : '',
                                         uId: user.uid,
                                         provider: user.providerData.length > 0 ? user.providerData[0].providerId : '',
                                         preferences: {}
                                     };
                                     context.commit('SET_CURRENT_USER', profile);
                                     resolve(profile);
                                 }
                                 else
                                 {
                                     store.commit('common/SHOW_SNACKBAR_ERROR', error);
                                     reject(error)
                                 }
                             }
                             await store.commit('common/WAITING', false);
                             return
                         }
                         if (this.state.auth.routing)
                         {
                             resolve(this.state.auth.currentUser)
                         }
                         else if (!this.state.auth.routing && !user)
                         {
                             resolve(null)
                         }
                    },error =>
                    {
                        reject(error)
                    })
                }
                else
                {
                    resolve(this.state.auth.currentUser)
                }
            })
        },
        UPDATE_CURRENT_USER: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.post('/user/', payload);
            updateAccountCommon(context, response.data, response.headers)
        },
        UPDATE_CURRENT_USER_NO_WAIT: async (context, payload) =>
        {
            const axios = await axiosInit();
            axios.post('/user/', payload).catch()
        },
        LOGOUT_AUTH: async (context) =>
        {
            localStorage.clear();
            await firebaseAuth.signOut();
            context.commit('SET_CURRENT_USER', null);
            store.commit('common/HIDE_SNACKBAR');
            store.commit('customerBilling/INIT_CUSTOMER_BILLING');
            return null
        },
        GET_TEST_PROTOCOL_SUITE: async (context) =>
        {
            // If less than 12 hours since we checked, skip server call
            if (context.state.testProtocolSuite && isBeforeCutoff(context.state.testProtocolSuite.lastTestProtocolSuiteUpdate, 12))
            {
                return
            }
            const axios = await axiosInit();
            const response = await axios.get('/user/testing-protocol',
            {
                params:
                {
                    updatedAt: context.state.testProtocolSuite.lastTestProtocolSuiteUpdate ? context.state.testProtocolSuite.lastTestProtocolSuiteUpdate : null
                }
            });
            if (200 === response.status)
            {
                const testProtocolSuite = response.data;
                for (const testProtocol of testProtocolSuite.testProtocols)
                {
                    testProtocol.torchLevelDisplay = !testProtocol.flashOn && testProtocol.torchLevel ? `${formatNumber(testProtocol.torchLevel * 100)}%` : 'N/A';
                    testProtocol.lightingModeDisplay = testProtocol.flashOn ? 'Flash' : 'Pulse';
                    testProtocol.videoDurationDisplay = `${formatNumber(testProtocol.videoDuration)} sec`;
                    testProtocol.torchDurationDisplay = !testProtocol.flashOn && testProtocol.torchDuration ? `${formatNumber(testProtocol.torchDuration)} sec` : 'N/A';
                    testProtocol.ambientLevelDisplay = testProtocol.ambientLevel ? `${formatNumber(testProtocol.ambientLevel * 100)}%` : 'N/A';
                    testProtocol.illuminationDelayDisplay = testProtocol.illuminationDelay ? `${formatNumber(testProtocol.illuminationDelay)} sec` : 'N/A';
                    testProtocol.pauseSeconds = `${formatNumber(testProtocol.pauseSeconds)} sec`;
                    testProtocol.noBaseline = testProtocol.noBaseline ? 'No' : 'Yes';
                    testProtocol.calculationMethod = formatCalculationMethod(testProtocol.calculationMethod)
                }
                context.commit('SET_TEST_PROTOCOL_SUITE', testProtocolSuite)
            }
            else
            {
                // Just update the last time checked
                context.commit('SET_TEST_PROTOCOL_SUITE')
            }
        }
    }
}

function formatCalculationMethod(calculationMethod)
{
    const parts = calculationMethod.split('_');
    let formattedCalculationMethod = '';
    let index = 0;
    for (let part of parts)
    {
        part = part.toLowerCase();
        part = part.charAt(0).toUpperCase() + part.slice(1);
        index += 1;
        if (index > 1)
        {
            formattedCalculationMethod += ' '
        }
        formattedCalculationMethod += part;
    }
    return formattedCalculationMethod
}

function updateAccountCommon(context, userAccount, headers)
{
    // If the user has an iTunes subscription
    if (userAccount.appleSubscription && userAccount.appleSubscription.productId)
    {
        if ('Reflex.sub.allaccess.monthly2' === userAccount.appleSubscription.productId || 'Reflex.sub.allaccess.monthly.noTrial' === userAccount.appleSubscription.productId)
        {
            userAccount.appleSubscription.productId = 'iTunes Monthly'
        }
        else if ('Reflex.sub.allaccess.yearly2' === userAccount.appleSubscription.productId || 'Reflex.sub.allaccess.yearly.noTrial' === userAccount.appleSubscription.productId)
        {
            userAccount.appleSubscription.productId = 'iTunes Yearly'
        }
        else if ('Reflex.sub.liteAccess2.monthly.noTrial' === userAccount.appleSubscription.productId)
        {
            userAccount.appleSubscription.productId = 'iTunes Critical Care'
        }
        else
        {
            userAccount.appleSubscription.productId = 'iTunes Monthly Pro'
        }
    }

    userAccount.isProUser = isProAccount(userAccount);

    context.commit('SET_CURRENT_USER', userAccount);
    context.commit('SET_LATEST_PORTAL_VER', parseInt(headers['web-portal-ver']))
}

function isProAccount(userAccount)
{
    if (userAccount.orgId && 'PRO' === userAccount.maxAppLevel.toUpperCase())
    {
        return true
    }
    if ('3' === userAccount.stripeSubscription.subscriberLevel || '3e' === userAccount.stripeSubscription.subscriberLevel || '999' === userAccount.stripeSubscription.subscriberLevel)
    {
        return true
    }
    return '3' === userAccount.appleSubscription.subscriberLevel || '3e' === userAccount.appleSubscription.subscriberLevel || '999' === userAccount.appleSubscription.subscriberLevel
}